import React from 'react';
import { VerticalTabsContextValue } from '../../VerticalTabs/VerticalTabsContext';
import { VerticalTabsItemProps } from '../VerticalTabsItem.types';
import { SIZE } from '../../VerticalTabs/VerticalTabs.constants';

type TabAffixProps = Pick<VerticalTabsContextValue, 'size'> & {
  children:
    | VerticalTabsItemProps['prefixIcon']
    | VerticalTabsItemProps['suffixIcon'];
  dataHook?: string;
  className?: string;
};

const Affix = ({ dataHook, children, size, className }: TabAffixProps) => {
  return children
    ? React.cloneElement(children, {
        size: size === SIZE.MEDIUM ? 24 : 18,
        className,
        'data-hook': dataHook,
      })
    : null;
};

export { Affix };
